import { differenceInDays } from 'date-fns'
import { useEffect, useState, useRef } from 'react'
import { isMobile } from 'react-device-detect'
import { useNavigate, useLocation } from 'react-router-dom'
import styled from 'styled-components'
import { IssuableAllCouponType, UsableItem } from '../../@types/coupon'
import {
  getIssuableAllCoupon,
  getUnUsableCountCoupon,
  getUnUsableCoupon,
  getUsableCountCoupon,
  getUsableCoupon,
} from '../../api/coupons'
import { Button } from '../../components/Button'
import MyCouponModalCenter from '../../components/myshopping/MyCouponModalCenter'
import MyShoppingSideBar from '../../components/myshopping/MyShoppingSideBar'
import { useCommonContext } from '../../components/provider/CommonProvider'
import { PageTitle } from '../../components/title/PageTitle'
import '../../css/Coupon.css'
import '../../css/myshopping.css'
import { plusComma } from '../../js/script'
import { getAccessToken } from '../../api/auth'
import { AFWebLinkType, RNPostMessage } from '../../js/postMessage'
import { useAppContext } from '../../components/provider/AppProvider'

export default function MyCoupon() {
  const [myItem, setMyItem] = useState<UsableItem[]>([])
  const [myItemCount, setMyItemCount] = useState<number>(0)
  const [myUnItem, setMyUnItem] = useState<UsableItem[]>([])
  const [myUnItemCount, setMyUnItemCount] = useState<number>(0)
  const [couponTab, setCouponTab] = useState<string>('보유')
  const [downloadable, setDownloadable] = useState<IssuableAllCouponType[]>([])

  const { setIsLottie } = useCommonContext()
  const { isAppView } = useAppContext()

  const navigate = useNavigate()
  const location = useLocation()

  const didRun = useRef(false)

  useEffect(() => {
    if (didRun.current) return
    didRun.current = true

    const isLogin = getAccessToken()
    if (isLogin) return

    alert('로그인 후 이용 가능합니다.')

    if (isAppView) {
      RNPostMessage(AFWebLinkType.goBack)
    } else {
      navigate('/', { replace: true })
    }
  }, [location.pathname])

  useEffect(() => {
    getUsableCoupon()
      .then((res) => {
        setMyItemCount(res.data.totalCount)
      })
      .catch((err) => console.log(err))
    getUnUsableCoupon()
      .then((res) => {
        setMyUnItemCount(res.data.totalCount)
        setIsLottie(false)
      })
      .catch((err) => console.log(err))
  }, [location.pathname])
  useEffect(() => {
    if (myItemCount !== 0) {
      getUsableCountCoupon(myItemCount)
        .then((res) => {
          setMyItem(res.data.items)
        })
        .catch((err) => console.log(err))
    }
    if (myUnItemCount !== 0) {
      getUnUsableCountCoupon(myUnItemCount)
        .then((res) => {
          setMyUnItem(res.data.items)
        })
        .catch((err) => console.log(err))
    }
  }, [myItemCount, myUnItemCount, location.pathname])

  useEffect(() => {
    setTimeout(() => {
      setIsLottie(false)
    }, 500)
  }, [couponTab])

  useEffect(() => {
    if (myItem.length === 0) {
      getIssuableAllCoupon().then((res) => {
        setDownloadable(res.data)
      })
    }
  }, [myItem])

  //  최근 본 내역 없을 때 박스 높이 조절
  useEffect(() => {
    if (!isMobile) return
    const contentsWrap = document.querySelector('.contents_wrap')
    if (!contentsWrap) return

    if (myItem.length === 0 || myUnItem.length === 0) {
      contentsWrap.classList.add('full')
    } else {
      contentsWrap.classList.remove('full')
    }
  }, [isMobile, myItem.length, myUnItem.length])

  return (
    <>
      {isMobile ? (
        <div className='main_wrap'>
          <div className='contents_wrap'>
            <PageTitle>마이 쿠폰</PageTitle>
            <div className='mycoupon'>
              <TabWrap>
                <Tab
                  className={couponTab === '보유' ? 'on' : ''}
                  onClick={() => {
                    setCouponTab('보유')
                    setIsLottie(true)
                  }}
                >
                  보유 쿠폰
                  {Number(myItemCount) !== 0 ? <span>{myItemCount}</span> : null}
                </Tab>
                <Tab
                  className={couponTab !== '보유' ? 'on' : ''}
                  onClick={() => {
                    setCouponTab('지난')
                    setIsLottie(true)
                  }}
                >
                  지난 쿠폰
                </Tab>
              </TabWrap>
              {couponTab === '보유' ? (
                myItem.length === 0 ? (
                  <div className='no_content_wrap'>
                    <div className='no_content'>
                      <p className='title'>보유한 쿠폰이 없습니다.</p>
                      <p className='sub_txt'>쿠폰페이지에서 다양한 혜택을 만나보세요.</p>
                      <button
                        onClick={() => {
                          navigate(`/coupon`)
                        }}
                      >
                        {downloadable.length}개의 쿠폰 받으러가기
                      </button>
                    </div>
                  </div>
                ) : (
                  <CouponWrap>
                    <CouponList>
                      {myItem?.map((el: any) => {
                        return <MyCouponItem el={el}></MyCouponItem>
                      })}
                    </CouponList>
                  </CouponWrap>
                )
              ) : myUnItem.length === 0 ? (
                <div className='no_content_wrap'>
                  <div className='no_content'>
                    <img src='/images/empty_logo.png' alt='' />
                    <p className='title gray'>지난 쿠폰이 없습니다.</p>
                  </div>
                </div>
              ) : (
                <CouponWrap>
                  <CouponList>
                    {myUnItem?.map((el: any) => {
                      return <MyCouponUsedItem el={el} couponTab={couponTab}></MyCouponUsedItem>
                    })}
                  </CouponList>
                </CouponWrap>
              )}
            </div>
          </div>
        </div>
      ) : (
        // pc
        <div className='main_wrap'>
          <div className={isMobile ? 'contents_wrap' : 'contents_wrap sidemenu_wrap full'}>
            <MyShoppingSideBar />
            <div className='myshopping_wrap'>
              <PageTitle>마이 쿠폰</PageTitle>
              <div className='mycoupon'>
                <div className='mycoupon_tap_wrap'>
                  <TabWrap>
                    <Tab
                      className={couponTab === '보유' ? 'on' : ''}
                      onClick={() => {
                        setCouponTab('보유')
                      }}
                    >
                      보유 쿠폰
                      {Number(myItemCount) !== 0 ? <span>{myItemCount}</span> : null}
                    </Tab>
                    <Tab
                      className={couponTab !== '보유' ? 'on' : ''}
                      onClick={() => {
                        setCouponTab('지난')
                      }}
                    >
                      지난 쿠폰
                    </Tab>
                  </TabWrap>
                </div>
                {couponTab === '보유' ? (
                  myItem.length === 0 ? (
                    <div className='no_content_wrap'>
                      <div className='no_content'>
                        <p className='title'>보유한 쿠폰이 없습니다.</p>
                        <p className='sub_txt'>쿠폰페이지에서 다양한 혜택을 만나보세요.</p>
                        <button
                          onClick={() => {
                            navigate(`/coupon`)
                          }}
                        >
                          쿠폰 받으러가기
                        </button>
                      </div>
                    </div>
                  ) : (
                    <CouponWrap>
                      <CouponList>
                        {myItem?.map((el: any) => {
                          return <MyCouponItem el={el}></MyCouponItem>
                        })}
                      </CouponList>
                    </CouponWrap>
                  )
                ) : myUnItem.length === 0 ? (
                  <div className='no_content_wrap'>
                    <div className='no_content'>
                      <img src='/images/empty_logo.png' alt='' />
                      <p className='title gray'>지난 쿠폰이 없습니다.</p>
                    </div>
                  </div>
                ) : (
                  <CouponWrap>
                    <CouponList>
                      {myUnItem?.map((el: any) => {
                        return <MyCouponUsedItem el={el} couponTab={couponTab}></MyCouponUsedItem>
                      })}
                    </CouponList>
                  </CouponWrap>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

function MyCouponItem({ el }: any) {
  const [couponModalCenter, setcouponModalCenter] = useState(false)
  const [expireDay, setExpireDay] = useState<any>()
  useEffect(() => {
    if (el && el.useEndYmdt) {
      const reviewDate = new Date(el.useEndYmdt.split(' ', 1)[0])
      reviewDate.setHours(0, 0, 0, 0)
      const today = new Date()
      today.setHours(0, 0, 0, 0)

      const result = differenceInDays(reviewDate, today)
      setExpireDay(result)
    }
  }, [])

  return (
    <>
      <div className='coupon_item'>
        <div className='f_box'>
          <em>
            {`${el.issueYmdt?.split(' ', 1).join('').replaceAll('-', '. ').replaceAll('. 0', '. ')} - ${el.useEndYmdt
              ?.split(' ', 1)
              .join('')
              .replaceAll('-', '. ')
              .replaceAll('. 0', '. ')}`}
            {expireDay < 5 ? (
              <i style={{ color: expireDay < 5 ? '#FF0000' : 'var(--colGray6)' }}>{expireDay}일 남음</i>
            ) : null}
          </em>
          <p>{el.couponName}</p>
          <span>
            {el.minSalePrice
              ? `최대 ${
                  el.discountAmt ? `${plusComma(el.discountAmt)}원 할인` : `${plusComma(el.maxDiscountAmt)}원 할인`
                }`
              : null}
          </span>
          <div>
            <strong>{el.discountAmt ? `${plusComma(el.discountAmt)}원` : `${el.discountRate}%`}</strong>
            <button
              type='button'
              onClick={() => {
                setcouponModalCenter(true)
              }}
            >
              사용안내
            </button>
          </div>
        </div>
      </div>
      {couponModalCenter ? (
        <MyCouponModalCenter
          setIsModal={setcouponModalCenter}
          item={[el]}
          selectCouponNo={el.couponNo}
        ></MyCouponModalCenter>
      ) : null}
    </>
  )
}

function MyCouponUsedItem({ el, couponTab }: any) {
  const [couponModalCenter, setcouponModalCenter] = useState(false)
  const [expireDay, setExpireDay] = useState<any>()
  useEffect(() => {
    if (el && el.useEndYmdt) {
      const reviewDate = new Date(el.useEndYmdt.split(' ', 1)[0])
      reviewDate.setHours(0, 0, 0, 0)
      const today = new Date()
      today.setHours(0, 0, 0, 0)

      const result = differenceInDays(reviewDate, today)
      setExpireDay(result)
    }
  }, [])

  return (
    <>
      <div className='coupon_item used'>
        <div className='f_box'>
          <em>
            {`${el.issueYmdt?.split(' ', 1).join('').replaceAll('-', '. ').replaceAll('. 0', '. ')} - ${el.useEndYmdt
              ?.split(' ', 1)
              .join('')
              .replaceAll('-', '. ')
              .replaceAll('. 0', '. ')}`}
            <i>{el.used ? '사용완료' : '기간만료'}</i>
          </em>
          <p>{el.couponName}</p>
          <span>{`${
            el.discountRate ? `최대 ${plusComma(el.discountRate)}% 할인` : `최대 ${plusComma(el.discountAmt)}원 할인`
          }`}</span>
          <div>
            <strong>{`${el.discountRate ? `${el.discountRate}%` : `${plusComma(el.discountAmt)}원`}`}</strong>
            {couponTab === '지난' ? null : (
              <button
                type='button'
                onClick={() => {
                  setcouponModalCenter(true)
                }}
              >
                사용안내
              </button>
            )}
          </div>
        </div>
      </div>
      {couponModalCenter ? (
        <MyCouponModalCenter
          setIsModal={setcouponModalCenter}
          item={[el]}
          selectCouponNo={el.couponNo}
        ></MyCouponModalCenter>
      ) : null}
    </>
  )
}

// 탭 Wrap
export const TabWrap = styled.div`
  width: 100%;
  display: flex;
  @media screen and (min-width: 768px) {
    width: 100%;
    padding: 0;
    margin: 0 auto;
    gap: 20px;
  }
`
// 상품 상세정보, 리뷰 탭
export const Tab = styled(Button)`
  flex: 1;
  padding: 15px 0;
  font-size: 16px;
  font-weight: 500;
  line-height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--colGray5);
  /* background: var(--colWhite); */
  border-bottom: 1px var(--colGray3) solid;
  gap: 4px;
  height: 48px;
  & span {
    display: inline-block;
    font-size: 16px;
    font-weight: 500;
    line-height: 18px;
    color: var(--colPointBlue);
    margin-left: 3px;
  }
  @media screen and (min-width: 768px) {
    flex: none;
    color: var(--colGray5);
    font-size: 16px;
    line-height: 18px;
    border-bottom: none;
    padding: 0 2px;
    position: relative;
    top: 1px;
    & span {
      display: inline-block;
      font-size: 16px;
      font-weight: 700;
      line-height: 18px;
      margin-left: 3px;
    }
  }
  &.on {
    color: var(--colBlack);
    border-bottom: 1px var(--colBlack) solid;
    @media screen and (min-width: 768px) {
      font-size: 16px;
      font-weight: 700;
      line-height: 18px;
      border-bottom: 2px var(--colBlack) solid;
    }
  }
`

export const CouponWrap = styled.div`
  padding: 20px 20px 48px;
  @media screen and (min-width: 768px) {
    width: 100%;
    margin: 0 auto;
    padding: 32px 0;
    flex: 1;
  }
  & .coupon_header {
    display: flex;
    padding: 12px 0;
    justify-content: space-between;
    align-items: center;

    & p {
      font-size: 16px;
      line-height: 24px;
      color: var(--colGray6);
      & em {
        font-style: normal;
        color: var(--colBlack);
        font-weight: 500;
      }
    }
    & .btn_box {
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 12px;
      & button {
        font-size: 16px;
        line-height: 24px;
        color: var(--colBlack);
        border: 0;
        background: transparent;
        font-weight: 500;
        padding: 0;
      }
      & i {
        width: 1px;
        height: 14px;
        background: var(--colGray3);
      }
    }
  }
`

export const CouponList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  @media screen and (min-width: 768px) {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 24px;
  }

  & .coupon_item {
    border: 1px solid var(--colGray3);
    border-radius: 6px;

    & .f_box {
      padding: 20px;
      @media screen and (min-width: 768px) {
        padding: 24px;
      }

      & em {
        display: block;
        margin-bottom: 8px;
        font-size: 12px;
        font-weight: 500;
        line-height: 15px;
        color: var(--colGray6);
        font-style: normal;
        @media screen and (min-width: 768px) {
          font-size: 14px;
          font-weight: 500;
          line-height: 18px;
          margin-bottom: 12px;
        }

        & i {
          display: inline-block;
          margin-left: 4px;
          font-size: 12px;
          line-height: 15px;
          color: #ff0000;
          font-style: normal;
          @media screen and (min-width: 768px) {
            font-size: 14px;
            font-weight: 500;
            line-height: 18px;
            margin-left: 8px;
          }
        }
      }
      & p {
        font-size: 15px;
        line-height: 20px;
        color: var(--colBlack);
        font-weight: 600;
        margin-bottom: 4px;
        @media screen and (min-width: 768px) {
          font-size: 18px;
          font-weight: 600;
          line-height: 24px;
          margin-bottom: 4px;
        }
      }
      & span {
        display: block;
        font-size: 12px;
        line-height: 15px;
        font-weight: 500;
        color: var(--colGray6);
        @media screen and (min-width: 768px) {
          font-size: 14px;
          font-weight: 500;
          line-height: 18px;
          margin-bottom: 12px;
        }
      }
      & div {
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
        gap: 4px;
        margin-top: 8px;
        @media screen and (min-width: 768px) {
          margin-top: 12px;
        }
        & strong {
          font-size: 24px;
          line-height: 26px;
          font-weight: 700;
          color: var(--colPointBlue);
          @media screen and (min-width: 768px) {
            font-size: 26px;
            font-weight: 700;
            line-height: 28px;
          }
        }
        & button {
          position: relative;
          font-size: 12px;
          line-height: 15px;
          color: var(--colGray6);
          border: 0;
          background: transparent;
          display: flex;
          justify-content: center;
          align-items: center;
          width: auto;
          padding: 0 10px 0 0;
          font-weight: 500;
          background: url('/images/icon_arrow_right_10_gray6.png') no-repeat right center;
          background-size: 10px;

          @media screen and (min-width: 768px) {
            font-size: 14px;
            font-weight: 500;
            line-height: 16px;
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 0 16px 0 0;
            cursor: pointer;
            background: url('/images/icon_arrow_right_16_gray6.png') no-repeat right center;
            background-size: 16px;
          }
        }
      }
    }

    & button {
      display: block;
      width: 100%;
      text-align: center;
      border: 0;
      background: var(--colGray3);
      padding: 16px 0;

      & span {
        position: relative;
        display: inline-block;
        padding-right: 20px;
        font-size: 14px;
        line-height: 16px;
        color: var(--colBlack);
      }
    }
  }
  & .used {
    & .f_box {
      & em {
        color: var(--colGray5);

        & i {
          color: var(--colGray5);
        }
      }
      & p {
        color: var(--colGray5);
      }
      & span {
        color: var(--colGray5);
      }
      & div {
        & strong {
          color: var(--colGray5);
        }
      }
    }
  }
`
